import React from 'react';
import Button from '../Button/Button';
const ItemShow = (props) => {
    let classColor = '';
    let buttonName = '?';
    let buttonColor = '';
    if (props.historyAnswers === 1) {
        classColor =' well';
        buttonName = props.tasksGame.Yes;
        buttonColor = ' Yes';
        }
    else { 
        if (props.historyAnswers === 2) {
            classColor = ' wrong';
            buttonName = props.tasksGame.No;
            buttonColor = ' No';
        }
    }

    return <div>
        <div className={props.className + classColor}> {props.value} </div>
        <Button className={props.classButton + buttonColor} value={buttonName} />
    </div>
}

export default ItemShow;